import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/workflows/{workflowId}/clone']['POST'];

const cloneWorkflow = async ({ id }: ThisApi['params']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/workflows/${id}/clone`);
  return response.data;
};

export default cloneWorkflow;
